import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.HunterPrerequisites;

type Props = {
  completedCount: number;
  totalCount: number;
};

export const PrerequisitesStatusHeader = ({
  completedCount,
  totalCount,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="h6">
        {t(RESOURCES.Title)} ({completedCount}/{totalCount})
      </Typography>
      {completedCount === totalCount ? (
        <CheckCircleOutlineIcon color="success" />
      ) : (
        <CancelOutlinedIcon color={completedCount > 0 ? "warning" : "error"} />
      )}
    </Box>
  );
};
